import type { DeviceAccess } from './deviceProbe'
import type { StringKey } from './i18n'

/**
 * `unknown` is not a permission block — nothing said the browser refused
 * anything, we just failed to verify a repair — so it must never render the
 * "browser is blocking your microphone" walkthrough title. Reuses the silent
 * copy: both are "we can't confirm you're heard", not "go fix a setting", and
 * `capabilityKind` already skips the permission steps for anything but `blocked`.
 */
export function micHelpTitleKey(device: 'mic' | 'camera', access: DeviceAccess): StringKey {
  if (device === 'camera') {
    if (access === 'missing') return 'cam.help.titleMissing'
    if (access === 'busy') return 'cam.help.titleBusy'
    return 'cam.help.titleBlocked'
  }
  if (access === 'missing') return 'mic.help.titleMissing'
  if (access === 'busy') return 'mic.help.titleBusy'
  if (access === 'silent' || access === 'unknown') return 'mic.help.titleSilent'
  return 'mic.help.titleBlocked'
}
